import { useState, useEffect } from 'react';

const AuthDebugger = () => {
  const [tokenInfo, setTokenInfo] = useState({
    exists: false,
    firstChars: '',
    length: 0,
    timestamp: new Date().getTime()
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    setTokenInfo({
      exists: !!token,
      firstChars: token ? `${token.substring(0, 10)}...` : '',
      length: token ? token.length : 0,
      timestamp: new Date().getTime()
    });
  }, []);

  return tokenInfo;
};

export const verifyAndRefreshToken = () => {
  const token = localStorage.getItem('token');
  
  const usuario = localStorage.getItem('usuario');
  
  if (!token && usuario) {
    try {
      const backupAuth = sessionStorage.getItem('auth_backup');
      if (backupAuth) {
        const parsedAuth = JSON.parse(backupAuth);
        if (parsedAuth && parsedAuth.token) {
          localStorage.setItem('token', parsedAuth.token);

          return true;
        }
      }
    } catch (error) {

    }
  }
  
  return !!token;
};

export const backupAuthInfo = () => {
  const token = localStorage.getItem('token');
  const usuario = localStorage.getItem('usuario');
  
  if (token && usuario) {
    try {
      sessionStorage.setItem('auth_backup', JSON.stringify({
        token,
        usuario,
        timestamp: new Date().getTime()
      }));
    } catch (error) {

    }
  }
};

export default AuthDebugger;
